module.exports = {
  IP: '2j6788q509.wicp.vip',
  port: '443'
  // IP: 'localhost',
  // port: '4000'
}
